<template>
  <div id="app-wrapper" :style="{ height: wrapperHeight + 'px' }">
    <div class="header-fixed-container" :style="headerStyle">
      <SiteHeader />
    </div>
    <div id="app" ref="appContent" :style="contentStyle">
      <router-view/>
      <SiteFooter />
    </div>
  </div>
</template>

<script>
import SiteHeader from '@/components/Header.vue'
import SiteFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      scale: 1,
      wrapperHeight: 'auto',
      resizeObserver: null
    }
  },
  computed: {
    contentStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: '1920px',
        minHeight: '100vh'
      }
    },
    headerStyle() {
      return {
        transform: `scale(${this.scale})`,
        transformOrigin: 'top left',
        width: '1920px', // 保持设计稿的固定宽度
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000 // 确保层级处于最上方
      }
    }
  },
  methods: {
    handleResize() {
      const designWidth = 1920
      this.scale = window.innerWidth / designWidth
      this.updateHeight()
    },
    updateHeight() {
      if (this.$refs.appContent) {
        const newHeight = this.$refs.appContent.offsetHeight * this.scale
        // Prevent infinite ResizeObserver loop by only updating if height changed significantly
        if (this.wrapperHeight === 'auto' || Math.abs(this.wrapperHeight - newHeight) > 1) {
          this.wrapperHeight = newHeight
        }
      }
    }
  },
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
    
    this.resizeObserver = new ResizeObserver(() => {
      this.updateHeight()
    })
    if (this.$refs.appContent) {
      this.resizeObserver.observe(this.$refs.appContent)
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }
}
</script>

<style>
@import './assets/styles/global.css';

body {
  overflow-x: hidden;
}

#app-wrapper {
  width: 100%;
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>